import React, { useContext, useEffect, useState } from "react";

import AddIcon from "@material-ui/icons/Add";
import { Button, Grid, Tooltip } from "@material-ui/core";

import Swal from "sweetalert2";

import { useHistory } from "react-router-dom";

import TableDefault from "../../components/grid/TableDefault";
import SearchInput from "../../components/basics/SearchInput";
import Loading from "../../components/basics/Loading";
import {
  findCNDAgenda,
  deleteCNDAgenda,
} from "../../repository/ERP/pub/CNDAgendaService";
import { CNDContext } from "../../context/CNDContext";
import filterTable from "../../utils/filterTable";
import { QueryParamsContext } from "../../context/QueryParamsContext";
import { notify } from "../../utils/notify";
import "./CND.css";

const CNDTabListagem = () => {
  const [dataRows, setDataRows] = useState([]);
  const [filterDataRows, setFilterDataRows] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const { optionsCND } = useContext(CNDContext);
  const { queryParams } = useContext(QueryParamsContext);
  const { push } = useHistory();

  useEffect(() => {
    const handleEditItem = (row) => {
      push("edicao", JSON.stringify({ ...row }));
    };

    const handleGetRows = async () => {
      try {
        setLoadingTable(true);
        const { data } = await findCNDAgenda(queryParams.empresa_cnpj);

        data.forEach((item) => {
          item.dataInicio = item.data_inicio
            ? item.data_inicio.split("-").reverse().join("/")
            : "";

          item.cnd = item.cnd.cnd;

          item.acoes = (
            <div>
              <Tooltip title="Editar">
                <img
                  src="/icons/edit.svg"
                  alt="Editar"
                  className="icon-edit-svg"
                  onClick={() => handleEditItem(item)}
                />
              </Tooltip>

              <Tooltip title="Deletar">
                <img
                  src="/icons/delete.svg"
                  alt="Deletar"
                  className="icon-delete-svg"
                  onClick={() => {
                    Swal.fire({
                      icon: "question",
                      text: "Tem certeza que deseja remover este registro?",
                      showConfirmButton: true,
                      showCancelButton: true,
                    }).then(async (result) => {
                      if (result.isConfirmed) {
                        try {
                          setLoading(true);
                          const resultApi = await deleteCNDAgenda(
                            item.id,
                            queryParams.empresa_cnpj
                          );

                          if (resultApi && resultApi.success) {
                            Swal.fire({
                              icon: "success",
                              text: "Registro removido com sucesso.",
                              showConfirmButton: true,
                              timer: 3000,
                            });

                            setRefresh((prev) => !prev);

                            return;
                          }

                          notify("Não foi possível remover registro.");
                        } catch (error) {
                          notify("Não foi possível remover registro.");
                          console.error(
                            "error CNDTabListagem delete item",
                            error
                          );
                        } finally {
                          setLoading(false);
                        }
                      }
                    });
                  }}
                />
              </Tooltip>
            </div>
          );
        });

        setDataRows(data);
        setFilterDataRows(data);
      } catch (error) {
        console.error("error useEffect CNDTabListagem", error);
      } finally {
        setLoadingTable(false);
      }
    };

    handleGetRows();
  }, [refresh, optionsCND, push, queryParams.empresa_cnpj]);

  const defaultTableColumns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
    },
    {
      id: "ambito",
      label: "Âmbito",
    },
    {
      id: "tipo_consulta",
      label: "Consulta",
    },
    { id: "cnd", label: "Certidão" },
    { id: "dataInicio", label: "Início do Controle" },
  ];

  const handleChangeFilter = (e) => {
    if (!e) return setFilterDataRows(dataRows);

    const newArr = filterTable({
      data: dataRows,
      text: e.target.value,
      columns: ["ambito", "tipo_consulta", "cnd", "dataInicio"],
    });

    setFilterDataRows(newArr);
  };

  const handleClickInsert = () => {
    push("cadastro");
  };

  return (
    <>
      <Loading open={loading} />
      <Grid container alignItems="center" justify="flex-start">
        <Grid item lg={5} md={8} sm={12} xs={12}>
          <SearchInput handleChange={handleChangeFilter} />
        </Grid>
      </Grid>

      <TableDefault
        loading={loadingTable}
        columns={defaultTableColumns}
        tableTitle={
          <Grid
            container
            alignItems="center"
            spacing={2}
            justify="space-between"
            item
            xs={12}
          >
            <Grid
              item
              container
              justify="flex-start"
              lg={6}
              md={8}
              sm={9}
              xs={9}
            >
              Listagem das CNDs cadastradas
            </Grid>

            <Grid item container justify="flex-end" lg={6} md={4} sm={3} xs={3}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleClickInsert}
              >
                <AddIcon />
                Inserir
              </Button>
            </Grid>
          </Grid>
        }
        values={filterDataRows}
      />
    </>
  );
};

export default CNDTabListagem;
